import qs from "qs";

export function paramsSerializerCommaFormat<T>(params: T): string {
  const stringifiedQuery = qs.stringify(params, { arrayFormat: "comma", encodeValuesOnly: true });
  return stringifiedQuery;
}
